import { ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps } from '@mui/material'
import { colours } from '../StyleConstants'

type Props = ToggleButtonGroupProps & {
    buttons: Button[],
    groupLabel?: string,
    variant?: string,
}

type Button = {
    value: string,
    label: string,
    disabled?: boolean,
    minWidth?: string
}

const LassoToggleButtons = (props: Props) => {
    const { buttons, groupLabel, variant, ...defaultProps } = props;
    return (
        <ToggleButtonGroup
            {...defaultProps}
        >
            {groupLabel &&
                <ToggleButton
                    sx={{
                        textTransform: "none",
                        "&:disabled": {
                            color: '#666',
                            backgroundColor: '#eee',
                            marginRight: '1px',
                        },
                        py: 0,
                    }}
                    value={''}
                    disabled={true}
                >
                    {groupLabel}
                </ToggleButton>
            }
            {buttons.map((button) => {
                return (
                    <ToggleButton

                        key={button.value}
                        sx={{
                            minWidth: button?.minWidth,
                            textTransform: "none",
                            py: variant === 'tiny' ? 0 : undefined,
                            color: colours.midnightBlue.blue160,
                            backgroundColor: colours.core.white,
                            fontWeight: 600,
                            "&.MuiToggleButtonGroup-middleButton, &.MuiToggleButtonGroup-lastButton": {
                                borderLeft: `1px solid ${colours.midnightBlue.blue20}`,
                            },
                            "&.MuiToggleButton-root.Mui-selected":
                                {
                                    backgroundColor: colours.orange.orange,
                                    color: colours.midnightBlue.blue,
                                }
                        }}
                        value={button.value}
                        disabled={button.disabled || false}
                    >
                        {button.label}
                    </ToggleButton>
                )
            })}
        </ToggleButtonGroup>
    )
}

export default LassoToggleButtons